export default {
  title: {
    ar: '!أحسنت',
    en: 'Nice Work!'
  },

  description: {
    ar: '.أجابتك الصحيحة أهّلتك للدخول في سحب على جلسات بادل لك أو لطفلك. اضغط على التالي وأدخل بياناتك للانضمام إلى السحب',
    en: 'Your correct answers earned you a raffle entry to win padel sessions for you or your child. Tap next and fill in your details to join the draw.'
  },

  enter: {
    ar: 'الدخول في السحب',
    en: 'Enter the Raffle'
  }
};
